import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
const _excluded = ["fallbackAsset"];
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
import { MigrationResult } from './migration-result';
export const migrateV0ToV1 = data => {
  const {
      fallbackAsset
    } = data,
    other = _objectWithoutProperties(data, _excluded);
  const updatedFallbackAsset = fallbackAsset != null && fallbackAsset !== '' ? {
    assetType: fallbackAsset !== null && fallbackAsset !== void 0 && fallbackAsset.includes('videos.datacamp.com') ? 'Video' : 'Image',
    assetUrl: fallbackAsset
  } : null;
  return new MigrationResult('v1', _objectSpread(_objectSpread({}, other), {}, {
    fallbackAsset: updatedFallbackAsset
  }));
};
const migrateV1ToV2 = data => {
  return new MigrationResult('v2', _objectSpread({}, data));
};
export const migrations = {
  v0: migrateV0ToV1,
  v1: migrateV1ToV2
};
export default migrations;